/* eslint-disable
    import/no-unresolved,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./documentPreview.scss');

const deps = [require('data/model/document').name, require('ui/web/modal').name];

module.exports = angular
  .module('bench.ui.documentPreview', deps)

  .directive('blDocumentPreview', () => ({
    restrict: 'E',
    scope: {
      documentId: '=',
      hideTitle: '@',
    },
    bindToController: true,
    template: require('./documentPreview.html'),
    controller: require('./documentPreviewCtrl.js'),
    controllerAs: 'vm',
  }));
